import { IReducerAction } from 'src/interfaces/redux';
export * from './autoplay.selectors';

export interface IAutoplayState {
  autoplayEnabled: boolean;
  isAutoplayVisible: boolean;
}

export const autoplayInitialState: IAutoplayState = {
  autoplayEnabled: false,
  isAutoplayVisible: false,
};

export enum AutoplayActionTypes {
  TOGGLE_AUTOPLAY_ENABLED = 'AUTOPLAY/TOGGLE_AUTOPLAY_ENABLED',
  SET_AUTOPLAY_ENABLED = 'AUTOPLAY/SET_AUTOPLAY_ENABLED',
  SHOW_AUTOPLAY = 'AUTOPLAY/SHOW_AUTOPLAY',
  HIDE_AUTOPLAY = 'AUTOPLAY/HIDE_AUTOPLAY',
}

export type AutoplayAction = IReducerAction<AutoplayActionTypes>;

export default function autoplayReducer(state: IAutoplayState = autoplayInitialState, action: AutoplayAction) {
  switch (action.type) {
    case AutoplayActionTypes.TOGGLE_AUTOPLAY_ENABLED:
      return { ...state, autoplayEnabled: !state.autoplayEnabled };
    case AutoplayActionTypes.SET_AUTOPLAY_ENABLED:
      return { ...state, autoplayEnabled: action.payload };
    case AutoplayActionTypes.SHOW_AUTOPLAY:
      return { ...state, isAutoplayVisible: true };
    case AutoplayActionTypes.HIDE_AUTOPLAY:
      return { ...state, isAutoplayVisible: false };
    default:
      return state;
  }
}
